 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"46a85d4e52626e86f3ffe47f8b93c77b892ef172","1":"c5bcfe03f3450ad796f008ae962d563470c424f1","8":"component---src-pages-404-js","9":"component---src-pages-account-addresses-js","10":"component---src-pages-account-coupons-js","11":"component---src-pages-account-favourites-js","12":"component---src-pages-account-index-js","13":"component---src-pages-account-loyalty-points-js","14":"component---src-pages-account-my-coupons-js","15":"component---src-pages-account-order-js","16":"component---src-pages-account-orders-js","17":"component---src-pages-account-payment-provider-tokens-js","18":"component---src-pages-account-profile-js","19":"component---src-pages-account-referral-js","20":"component---src-pages-articles-js","21":"component---src-pages-brands-js","22":"component---src-pages-cart-js","23":"component---src-pages-categories-js","24":"component---src-pages-checkout-complete-js","25":"component---src-pages-checkout-completed-js","26":"component---src-pages-checkout-index-js","27":"component---src-pages-checkout-payment-failed-js","28":"component---src-pages-checkout-payment-processing-js","29":"component---src-pages-content-group-js","30":"component---src-pages-dine-in-js","31":"component---src-pages-dine-in-order-placed-js","32":"component---src-pages-enquiry-js","33":"component---src-pages-health-check-js","34":"component---src-pages-index-js","35":"component---src-pages-login-js","36":"component---src-pages-logout-js","37":"component---src-pages-oauth-js","38":"component---src-pages-pages-js","39":"component---src-pages-processing-js","40":"component---src-pages-product-js","41":"component---src-pages-products-all-js","42":"component---src-pages-products-comparison-js","43":"component---src-pages-products-js","44":"component---src-pages-public-coupons-js","45":"component---src-pages-registration-js","46":"component---src-pages-reset-password-js","47":"component---src-pages-start-order-js","48":"component---src-pages-store-locations-js","49":"component---src-pages-stores-js"}[chunkId]||chunkId) + "-" + {"0":"15fcc7279911600a1b47","1":"441a836ce90737d21806","8":"e6d308c96a25d9e0a28b","9":"9a28b4d16bc143b93d1e","10":"c3282dc10cad3359e5ad","11":"e42a2abdd9cda07cd60d","12":"95b063f3e3baa7a5325e","13":"1cc0327f917a0bb87f1f","14":"4c3c213d20789a693515","15":"ddc3fd24ec83e9f3db8f","16":"cb9ca54f570e314839b1","17":"061532c6d60fed2a8488","18":"ee17ad1907d6f9e335c2","19":"b3afc7630f30299912c9","20":"24cb96944771543ae75a","21":"e82d0bf1e3f7ac8f4073","22":"3fe45041c904499241b8","23":"ba10f88f4d86fc2007c6","24":"450e716209aa111e98a1","25":"7093d1d9941f313af849","26":"29ca2e9ff243ef2ce55c","27":"8891f57836a87f3259ff","28":"50d55faf50ae9a8f4e70","29":"115ad64460e66a681d29","30":"582ac98edad72fcd0efd","31":"191118ad4f84faf41aef","32":"a11bcd0dd705f15fbd03","33":"ce48e8630b6c05553fa3","34":"c82210b62495044dd814","35":"cd3a7add6263e5db2aad","36":"4a577a5217210dc3d326","37":"1d37e195ef114f5f2b2a","38":"0a763714469efccfa4d4","39":"84414bb224b0225cdfef","40":"2c7da292f8f095b7327f","41":"77308e1ddfb1227d8461","42":"a0eac816b88d5f7f2bd6","43":"595eebf731fd7825996e","44":"40a84d52f74a148f065b","45":"98f5049b618f121da5df","46":"5613793be9d29038b5dd","47":"0c4ca0b01288015022b7","48":"ac490c4e0ed28dd0441c","49":"81570a07e286691b7879","55":"0b21056771bd52a16d3e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
